import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { SIZES } from '@fupa/fupa-uikit';
import { reduxSelectDistrict } from 'app/hooks/reduxSelectDistrict';
import { sponsoringPartnerByDistrict } from 'app/components/partner/SiteSponsoringByDistrict';
import { sponsoringPartnerByRegion } from 'app/components/partner/SiteSponsoringByRegion';
import { generateUniqueTemplateKey } from 'app/helpers/gtm';
import { useLocation } from 'react-router';
const logoWidth = 160;
const logoHeight = 20;
const Container = styled.div.withConfig({
  componentId: "sc-1ql518l-0"
})(["display:flex;width:", "rem;height:", "rem;justify-content:", ";margin-bottom:", ";a{display:inherit;width:inherit;height:inherit;justify-content:inherit;}"], logoWidth / 16, logoHeight / 16, props => props.justify || 'left', SIZES['8']);
const Logo = styled.img.withConfig({
  componentId: "sc-1ql518l-1"
})(["align-self:center;max-width:", "rem;max-height:", "rem;"], logoWidth / 16, logoHeight / 16);
const enabledTemplates = ['region_index', 'news_index'];
const SiteSponsoring = _ref => {
  var _district$region;
  let {
    className
  } = _ref;
  const district = useSelector(reduxSelectDistrict);
  const {
    pathname
  } = useLocation();
  const {
    template
  } = generateUniqueTemplateKey(pathname);
  if (!enabledTemplates.includes(template)) {
    return null;
  }
  if (!district.slug || !(district !== null && district !== void 0 && (_district$region = district.region) !== null && _district$region !== void 0 && _district$region.slug)) {
    return null;
  }
  const partnerList = sponsoringPartnerByDistrict(district.slug) || sponsoringPartnerByRegion(district.region.slug);
  if (!partnerList) {
    return null;
  }
  return partnerList.map((partner, index) => {
    return /*#__PURE__*/React.createElement(Container, {
      key: index,
      justify: partner.justify,
      className: className
    }, /*#__PURE__*/React.createElement("a", {
      "data-google-interstitial": "false",
      target: "_blank",
      href: partner.link,
      rel: "nofollow"
    }, /*#__PURE__*/React.createElement(Logo, {
      src: partner.imgPath,
      width: "auto",
      height: "auto",
      alt: partner.sponsor
    })));
  });
};
export { SiteSponsoring };